import React, { Component } from 'react';
import { Card, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, CardFooter, InputGroup, InputGroupAddon, InputGroupText, CardHeader, CardBody, Row, Col } from "reactstrap";
import { renderToString } from 'react-dom/server'
import ImageUploader from '../../components/Products/ImageUploader/ImageUploader.jsx';
import { Label } from '../../components/UI/Form/Label/Label';
import { Prompt } from 'react-router-dom';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import ReactTooltip from 'react-tooltip'
import axios from 'axios';
import * as actionCreator from '../../store/action/index';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../components/Loader/Loader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Spinner from '../../components/Spinner/Spinner';
import { Line } from 'rc-progress';
import SliderFront from "../../components/SliderFront/SliderFront";



import {
    ProductPenerbitGeneral,
    getSliderPublisher,
    getSliderPublisherById,
    CreateSliderPublisher,
    updateSliderPublisher,
    deleteSliderPublisher,
} from '../../api/index';


class SliderPublisherEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            penerbit: [],
            penerbit_general_options: [],
            order: "",
            hyperlink: "",
            saveable: true,
            modal: false,
            thumbnailFile: [],
            productImagesUrl: [],
            sumFilled: 0,
            formNotFilledYet: [],
            prompt: true,
            edit_status: "new",  

        }
    }
    //order
    onChangeNumberHandler = (event) => {

        // validasi input tidak boleh huruf
        let values = event.target.value.toString().replace(/\,/g, '');
        // let isNum = /^\d+$/.test(values); // tanpakoma
        let isNum = /^[0-9]+\.?[0-9]*$/.test(values); // dengan koma output true or false                         
        let key = event.target.name;

        while (values.charAt(0) === '0') {
            values = values.substr(1);
        }

        if (isNum || event.target.value === null) {
            this.setState({ [key]: (values) })
        }
        else if (values.length <= 1) {
            this.setState({ [key]: 0 })
        }
        this.countFilled();
    }

    // newFormHandler = (event) => {
    //     event.preventDefault();
    //     let name = event.target.name;
    //     this.setState({ [name]: true, modal: true })
    // }

    // hideModal = () => {
    //     this.setState({
    //         modal: !this.state.modal
    //     })
    // }
    //button
     onUpdateHandler = (event) => {
        event.preventDefault();
        this.setState({ prompt: false }, () => {
            const content = this.state;
            event.preventDefault();
            updateSliderPublisher(content).then(res => {
                if (res.status === "success") {
                    const toaster = {
                        isOpenToast: true,
                        toastMessage: res.data.order + " Berhasil diUpdate",
                        toastType: 'success',
                    }
                    this.props.toggleToaster(toaster)
                    this.props.history.replace('/dashboard/slider-publisher');
                    this.props.history.push('/dashboard/slider-publisher');
                }
            }).catch(err => console.log(err))
        })
    }
    onSaveHandler = (event) => {
    event.preventDefault();
    this.setState({ prompt: false }, () => {
        const payload = this.makePayload();
        console.log("Payload dikirim:", payload); // biar bisa dicek di console
        CreateSliderPublisher(payload)
        .then(res => {
            toast.success("Berhasil tambah slider");
            this.props.history.replace('/dashboard/slider-publisher');
        })
        .catch(err => {
            console.log("Error:", err.response?.data || err.message);
            toast.warn("Whoops Something Error: " + (err.response?.data?.message || err.message));
        });
    });
    };

    makePayload = () => {
    const penerbitValue = Array.isArray(this.state.penerbit)
        ? this.state.penerbit.map(p => p.value)   // ambil ID saja
        : this.state.penerbit?.value
        ? [this.state.penerbit.value]
        : [];
    const slideUrl = this.state.productImagesUrl[0]?.secure_url || null;

    return {
        id: this.state.productId,
        hyperlink: this.state.hyperlink,
        slidebar: slideUrl,
        penerbitId: penerbitValue,
        order: Number(this.state.order) || 0,
        companyId: this.props.ui?.companyId || 1,
        name: "Slider Publisher",
    };
    };

    

        
   
    // Image Processing 
    onDrop = (files, rejectedFiles) => {
        if (rejectedFiles.length > 0) {
            toast.error(rejectedFiles.length + " file ditolak karena melebihi ukuran 2MB. Ini akan berdampak pada kecepatan loading yang akan lama jika melebihi dari ukuran tersebut. Kasihan yang pakai koneksi esia hidayah :(")
        }

        this.setState({ saveable: false })
        const max_file_count = 1 - this.state.thumbnailFile.length;
        const array_images = this.state.thumbnailFile.concat(
            files.slice(0, max_file_count).map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
            ));

        this.setState({ thumbnailFile: array_images });
        // uploading to cloudinary directly
        files.slice(0, max_file_count).map((file) => {
            this.handleUploadImages(file).then(() => {
                this.setState({ saveable: true })
                this.countFilled();
            });
        })

    }

    // This function does the uploading to cloudinary
    handleUploadImages = (image) => {
        // uploads is an array that would hold all the post methods for each image to be uploaded, then we'd use axios.all()

        // our formdata
        const formData = new FormData();
        formData.append("file", image);
        formData.append("tags", ['product']); // Add tags for the images - {Array}
        formData.append("upload_preset", "blst_product"); // Replace the preset name with your own
        formData.append("api_key", "899241999449336"); // Replace API key with your own Cloudinary API key
        formData.append("folder", "product");
        formData.append("quality", "low");
        formData.append("timestamp", (Date.now() / 1000) | 0);

        // Replace cloudinary upload URL with yours
        return axios.post(
            "https://api.cloudinary.com/v1_1/blstipb2020/image/upload",
            formData,
            { headers: { "X-Requested-With": "XMLHttpRequest" } })
            .then(response => {
                console.log(response.data)
                // const oldImages = this.state.productImagesUrl;
                const newImages = response.data;
                const newArrayofImages = this.state.productImagesUrl.concat(newImages);
                this.setState({ productImagesUrl: newArrayofImages });
            }).catch(err => console.log(err))
    }

    pushFormNotif = (sum) => {
        const notif = [];
        if (this.state.penerbit === null) { notif.push("Penerbit belum diisi")};
        if (this.state.order === '') { notif.push("Nomer Order belum diisi")};
        if (this.state.hyperlink === '') { notif.push("Link belum diisi")};
        if (this.state.productImagesUrl.length === 0) { notif.push("Belum ada Gambar Produk") };


        this.setState({ formNotFilledYet: notif });
    }

    // Validation
    countFilled = () => {
        // basic
        const penerbit = this.state.penerbit && this.state.penerbit.value !== '' ? 1 : 0;
        const order = this.state.order !== '' ? 1 : 0;
        const hyperlink = this.state.hyperlink !== '' ? 1 : 0;
        const productImagesUrl = this.state.productImagesUrl.length !== 0 ? 1 : 0;
       
        const sum =
            [ 
                penerbit,
                order,
                hyperlink,
                productImagesUrl,
            ];

        this.pushFormNotif(sum);

        const sums = sum.reduce((a, b) => a + b, 0);
        const pembagi = sum.length;
        const percent = (sums / pembagi) * 100;

        this.setState({ sumFilled: Math.ceil(percent) })
    }


    deleteImageHandler = (event, index) => {
        event.preventDefault();
        const public_id = this.state.productImagesUrl[index];

        if (typeof public_id !== 'undefined') {
            axios.delete("https://api.cloudinary.com/v1_1/blst/image/upload?public_ids[]=" + public_id.public_id).then(res => {
                console.log(res)
            });
        }

        const del1 = this.state.thumbnailFile.splice(index, 1);
        const del2 = this.state.productImagesUrl.splice(index, 1);
        Promise.all([del1, del2]).then(() => {
        })
        this.setState({ thumbnailFile: this.state.thumbnailFile, productImagesUrl: this.state.productImagesUrl });
    }

    componentWillUnmount() {
        // Make sure to revoke the data uris to avoid memory leaks
        this.state.thumbnailFile.forEach(file => URL.revokeObjectURL(file.preview))
    }

    componentWillMount() {

    }

    componentDidMount() {
        window.scrollTo(0, 0);

        const penerbit = [];
        const contentpenerbit = {};
            ProductPenerbitGeneral(contentpenerbit)
                .then(res => {
                res.map((value) => {
                    penerbit.push({
                    id: value.id,
                    value: value.id,
                    label: value.name_penerbit
                    });
                });
                })
                .then(() => {
                this.setState({ penerbit_general_options: penerbit });
                this.props.setLoading(false);
                })
                .catch(err => {
                toast.warn("Network Error, Can't get category data from server " + err);
                this.props.setLoading(false);
                });

            const { id } = this.props.match.params;

            if (id) {
                this.setState({ isFetching: true, edit_status: "edit" });
                const content = { id };

                getSliderPublisherById(id)

                .then(res => {
                    this.setState({ edit_status: "edit" });

                    const pictures = [];
                    const picture_url = [];

                    //handle slidebar tunggal
                    if (res.slidebar) {
                    const file = new File([], "slidebar.jpg");
                    pictures.push(Object.assign(file, { preview: res.slidebar }));
                    picture_url.push({ url: res.slidebar, secure_url: res.slidebar});
                    }

                    //handle array Pictures kalau ada
                    if (Array.isArray(res.Pictures)) {
                    res.Pictures.forEach((value) => {
                        const file = new File([], value.original_filename, {
                        lastModified: new Date(value.updated_at).getTime(),
                        });
                        pictures.push(Object.assign(file, { preview: value.url_medium }));

                        picture_url.push({
                        public_id: value.public_id,
                        alt: value.alt,
                        bytes: value.size,
                        original_filename: value.original_filename,
                        signature: value.signature
                        });
                    });
                    }

                    this.setState({
                    thumbnailFile: pictures,
                    productImagesUrl: picture_url,
                    order: res.order,
                    hyperlink: res.hyperlink,
                    //   penerbit: res.Penerbit
                    //     ? {
                    //         id: res.Penerbit.id,
                    //         label: "Penerbit " + res.penerbitId,
                    //         value: res.Penerbit.id,
                    //       }
                    //     : null,
                    penerbit: res.Penerbit 
                        ? [{ 
                            id: res.Penerbit.id, 
                            label: res.Penerbit.name_penerbit, 
                            value: res.Penerbit.id 
                            }]
                        : [],
                    saveable: true,
                    // productId: res.id,
                    pb: res.pb ?? 0,
                    }, () => {
                    this.countFilled();
                    this.setState({ isFetching: false });
                    });
                })
                .catch(err => {
                    console.error("Error getSliderPublisherById:", err);
                    this.setState({ isFetching: false });
                });
            }
            }


                showToaster = (message) => {
                    const snackBarOption = {
                        isOpen: true,
                        text: message
                    };
                }

                // fungsi untuk mencari string di array digunakan di logic option
                searchStringInArray = (string, myArray) => {
                    for (var i = 0; i < myArray.length; i++) {
                        if (myArray[i].label === string) {
                            return myArray[i];
                        }
                    }

                }

    render() {
        let modalform = null;
        let titlemodal = null;
        let status = false;

        let color = 'grey';
        if (this.state.sumFilled < 20) {
            color = '#fb5a5a';
        } else if (this.state.sumFilled < 40) {
            color = '#fbb35a';
        } else if (this.state.sumFilled < 60) {
            color = '#fbe75a';
        } else if (this.state.sumFilled < 80) {
            color = '#5ae5fb';
        } else {
            color = '#5bd400';
        }

        let datatipform = null;
        if (this.state.formNotFilledYet !== null) {
            datatipform = this.state.formNotFilledYet.map((value, index) => (
                <div>{value}</div>
            ))
        }
      

        return (   
            <div className="content">
                {this.state.isFetching ? (<div style={{ width: '100%', height: '85vh' }}>
                    <Spinner></Spinner>
                </div>) : (
                        <div className="progress-bar-class">
                            <ReactTooltip />
                            <span>Filled Percentage <b>{this.state.sumFilled}%</b></span>
                            <Line data-html={true} data-tip={renderToString(datatipform)} percent={this.state.sumFilled} strokeWidth="2" strokeColor={color} />
                        </div>
                    )}
                <Prompt when={this.state.prompt} message="You have unsaved form data. Are you sure you want to leave?" />
                {/* Modal Tambah */}
                <Modal isOpen={this.state.modal} fade={false} toggle={this.hideModal}>
                    <form onSubmit={(event) => this.AddButtonHandler(event)}>
                        <ModalHeader>
                            {titlemodal}
                        </ModalHeader>
                        <ModalBody>
                            {modalform}
                            {status ? <Button disabled size="sm">Add</Button> : <Button onClick={(event) => this.AddButtonHandler(event)} size="sm">Add</Button>}
                        </ModalBody>
                    </form>
                </Modal>
                <form>
                    <Row>
                        <Col md={4} xs={12}>
                            <Card className="card-user">
                                <CardHeader>
                                    <h6>Display Slider</h6>
                                </CardHeader>
                                <CardBody>
                                    <ImageUploader onDrop={this.onDrop} deleted={this.deleteImageHandler} filepreview={this.state.thumbnailFile} maxUpload={1} />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={8} xs={12}>
                            {/* General Information */}
                            <Card className="card-user">
                                <CardHeader>
                                    <h6>Slider Information</h6>
                                </CardHeader>
                                <CardBody>
                                     <Col md={12}>
                                        <ReactTooltip />
                                        <Label for="name" required>Publishing <small data-tip="Hubungi tim IT untuk menambahan data jika tidak tersedia">/ Penerbit</small></Label>
                                        <Select
                                            onChange={(val) => this.setState({ penerbit: val }, () => { this.countFilled() })}
                                            isMulti
                                            name="penerbit"
                                            value={this.state.penerbit || []}
                                            className="basic-multi-select"
                                            options={this.state.penerbit_general_options}
                                            
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <Label for="name" required>Order <small>/ Order</small></Label>
                                        <Input type="text" value={this.state.order || ""} name="order" onChange={(event) => this.setState({ order: event.target.value }, () => { this.countFilled() })}></Input>
                                    </Col>
                                    <Col md={12}>
                                        <Label for="name" required>URL<small>/ Link</small></Label>
                                        <Input type="text" value={this.state.hyperlink || ""} name="hyperlink" onChange={(event) => this.setState({ hyperlink: event.target.value }, () => { this.countFilled() })}></Input>
                                    </Col>  
                                
                                </CardBody>
                                <Row >
                                <Col md={12} style={{ textAlign: 'right' }}>
                                    {this.state.saveable && this.state.sumFilled == 100 && this.state.thumbnailFile.length > 0 ? (
                                        <div>
                                            <Button onClick={(event) => this.props.history.push('/dashboard/slider-publisher')} color="secondary">Cancel</Button>
                                            {/* <Button color="secondary" >Save & Add New</Button>
                        <Button color="secondary" >Copy & Add New</Button>                         */}
                                            {this.state.edit_status !== "edit" ? (<Button onClick={this.onSaveHandler} color="success" >Save</Button>) : (<Button onClick={this.onUpdateHandler} color="success" >Update</Button>)}
                                        </div>
                                    ) : (
                                            <div>
                                                <Loader text="Waiting for you" />
                                            </div>
                                        )}
                                </Col>
                            </Row>
                            </Card>

                        </Col>
                    </Row>

                </form>
                <ToastContainer />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ui: state.ui
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleNotif: (message) => dispatch(actionCreator.toggleNotification(message)),
        setLoading: (data) => dispatch(actionCreator.toggleLoading(data)),
        toggleToaster: (payload) => dispatch(actionCreator.toggleToaster(payload))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SliderPublisherEditor);
